import React, { CSSProperties, FunctionComponent, memo } from 'react'
import styles from './TaskGroup.module.sass'
import TaskTabs from '../../navigation/TaskTabs/TaskTabs'
import Button from '../../controls/Button/Button'
import { EMPTY_TASK, taskStatusToColor } from '../../../responses/tasks'
import clsx from 'clsx'
import { ID } from '../../../types/UtilityTypes'
import { PERMISSIONS } from '../../../constants/permissions'
import { useRootDispatch, useRootSelector } from '../../../utils/hooks'
import { TaskStatus } from '../../../constants/enums'
import { lineTasksSelector } from '../../../utils/selectors'
import { taskActions } from '../../../redux/data/task/task-actions'
import PlusIcon from 'files/plus.svg'
import TaskContent from '../TaskContent/TaskContent'
import { entityIdPredicate } from '../../../utils/entity-utils'
import { TaskEditState } from '../../../redux/data/task/task-reducer'
import { setLightness } from 'polished'
import { HasAnyPermission } from '../HasPermission'

interface Props {
    className?: string,
    taskId: ID,
    parentId?: ID,
    objectId: ID,
    projectId: ID,
    hideLink?: boolean,
    onChange?: (taskId: ID) => void,
}

const TaskGroup: FunctionComponent<Props> = ({onChange, ...props}) => {
    const line = useRootSelector(lineTasksSelector(props.parentId))
    const task = line.find(entityIdPredicate(props.taskId)) ?? EMPTY_TASK
    const dispatch = useRootDispatch()
    const editState = useRootSelector(state => state.data.task.editState)
    const isAppend = TaskEditState.is.append(editState) && editState.parentId == props.parentId

    return <div
        className={clsx(props.className, styles.group)}
        style={{'--background': setLightness(0.95, taskStatusToColor(props.taskId === EMPTY_TASK.id ? TaskStatus.REQUESTED : task.status_id))} as CSSProperties}
    >
        <div className={styles.header}>
            <TaskTabs
                activeId={props.taskId}
                items={line}
                onChange={onChange}
                append={isAppend}
                editedId={TaskEditState.is.update(editState) ? editState.task.id : undefined}
            />
            <HasAnyPermission
                condition={!isAppend && !!props.parentId}
                permissions={[PERMISSIONS.TASK.REQUEST, PERMISSIONS.TASK.OPEN]}
            >
                <Button
                    className={styles.addButton}
                    title={'Добавить задачу'}
                    onClick={() => {
                        onChange?.(EMPTY_TASK.id)
                        dispatch(taskActions.startAppend({
                            objectId: task.project_work_object_id,
                            parentId: props.parentId ?? 0,
                        }))
                    }}
                >
                    <PlusIcon/>
                </Button>
            </HasAnyPermission>
        </div>
        <div className={styles.content}>
            <TaskContent
                task={task}
                parentId={props.parentId}
                objectId={props.objectId}
                projectId={props.projectId}
                hideLink={props.hideLink}
            />
        </div>
    </div>
}

export default memo(TaskGroup)